import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const updateUserProfile = async (formData) => {
  try {
    const config = {
      headers: {
       'Content-Type': 'application/json', // ✅ REQUIRED
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    };

     const { data } = await api.put(
      `${API_BASE_URL}api/users/profile`,
      formData,
      config
    );
    return { success: true, data };
  } catch (error) {
    console.error('❌ API error:', error.response?.data || error.message);
    return {
      success: false,
      error: error.response?.data?.message || 'Update failed'
    };
  }
};

export const getUserProfile = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Accept-Language": localStorage.getItem("lang") || "en",
      },
    };
    const { data } = await api.get(`${API_BASE_URL}api/users/profile`, config);
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.message || "Failed to fetch user",
    };
  }
};


export const deleteUser = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    };

    const response = await api.delete(`${API_BASE_URL}/users/profile`, config);
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.message || "Delete failed"
    };
  }
};

export const exportProductsExcel = async (params = {}) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Accept-Language": localStorage.getItem("lang") || "en",
    },
    responseType: "blob",
    params,
  };
  const url = `${API_BASE_URL}api/products/export`;
  return api.get(url, config);
};

export async function getTenantLimitsUsage(vendorStoreId) {
  try {
    const { data } = await api.get(`/usage/limits/${vendorStoreId}`);
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.response?.data?.error || e.message };
  }
}


// STAFF Management API

export async function createStaffUser(payload) {
  try {
    const { data } = await api.post(`${API_BASE_URL}api/users/role`, payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.response?.data?.message || e.message };
  }
}
export async function listStaffUsers() {
  try {
    const { data } = await api.get(`${API_BASE_URL}api/users/role`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.response?.data?.message || e.message };
  }
}
export async function updateStaffUser(id, payload) {
  try {
    const { data } = await api.put(`${API_BASE_URL}api/users/role/${id}`, payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.response?.data?.message || e.message };
  }
}
export async function deleteStaffUser(id) {
  try {
    const { data } = await api.delete(`${API_BASE_URL}api/users/role/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.response?.data?.message || e.message };
  }
}